import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "calendar-header-options" }
const _hoisted_2 = { class: "header-month-wrap" }
const _hoisted_3 = { class: "header-label-wrap" }
const _hoisted_4 = { class: "header-month-label" }
const _hoisted_5 = {
  key: 0,
  class: "header-year-label"
}
const _hoisted_6 = { class: "header-month-chevrons" }

import ButtonCustom from '@/components/elements/ButtonCustom.vue';
import EventBus from '@/utilities/eventBus';
import useTranslate from '@/utilities/composables/useTranslate';
import { ref, onUnmounted, computed } from 'vue';
import format from 'date-fns/format';
import isSameYear from 'date-fns/isSameYear';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarHeaderOptions',
  setup(__props) {

const { translate } = useTranslate();

const currentDate = ref<Date>(new Date());
const currentMonthLabel = ref<string>(format(currentDate.value, 'LLLL', { weekStartsOn: 1 }));
const currentYearLabel = ref<string>(format(currentDate.value, 'yyyy', { weekStartsOn: 1 }));

const isDifferentYear = computed(() => !isSameYear(currentDate.value, Date.now()));

const moveToStart = () => {
  EventBus.$emit('calendar:moveToStart');
};

const handleChangeMonth = (value: number) => {
  EventBus.$emit('calendar:changeMonth', value);
};

const setCurrentMonthLabel = (date: Date) => {
  currentDate.value = date;
  currentMonthLabel.value = format(date, 'LLLL', { weekStartsOn: 1 });
  currentYearLabel.value = format(date, 'yyyy', { weekStartsOn: 1 });
};
EventBus.$on('calendar:currentMonthChanged', setCurrentMonthLabel);

const handleOnUnmounted = () => {
  EventBus.$off('calendar:currentMonthChanged', setCurrentMonthLabel);
};

onUnmounted(handleOnUnmounted);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(currentMonthLabel.value), 1),
        _cache[2] || (_cache[2] = _createTextVNode()),
        (isDifferentYear.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(currentYearLabel.value), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ButtonCustom, {
          "custom-icon-name": "chevron-up",
          "custom-icon-color": "",
          "custom-icon-size": "16px",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeMonth(-1)))
        }),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _createVNode(ButtonCustom, {
          "custom-icon-name": "chevron-down",
          "custom-icon-color": "",
          "custom-icon-size": "16px",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeMonth(1)))
        })
      ])
    ]),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createVNode(ButtonCustom, {
      class: "header-today-button",
      text: _unref(translate)('today'),
      onClick: moveToStart
    }, null, 8, ["text"])
  ]))
}
}

})